import { Chip, TableCell, TableRow, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function metricsStatusChipColor(metricsStatus) {
  if (metricsStatus === 'final') {
    return 'success';
  }
  if (metricsStatus === 'partial') {
    return 'warning';
  }
  return 'default';
}

function formatSendDate(campaign) {
  const raw = campaign.sentAt || campaign.testSentAt || campaign.createdAt;
  if (typeof raw !== 'string' || raw.length === 0) {
    return '—';
  }
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) {
    return raw;
  }
  return parsed.toLocaleString();
}

function NewsletterCampaignTableRow({ campaign }) {
  return (
    <TableRow hover>
      <TableCell>
        <Typography
          component={RouterLink}
          to={`/newsletter-campaigns/${encodeURIComponent(campaign.id)}`}
          variant="body2"
          sx={{ color: 'primary.main' }}
        >
          {campaign.issueName}
        </Typography>
      </TableCell>
      <TableCell>{formatSendDate(campaign)}</TableCell>
      <TableCell>{campaign.subject}</TableCell>
      <TableCell align="right">{campaign.audienceSize}</TableCell>
      <TableCell align="right">{campaign.metrics.sent}</TableCell>
      <TableCell align="right">{campaign.metrics.delivered}</TableCell>
      <TableCell align="right">{campaign.metrics.bounced}</TableCell>
      <TableCell align="right">{campaign.metrics.uniqueClickers}</TableCell>
      <TableCell align="right">{campaign.metrics.totalClicks}</TableCell>
      <TableCell align="right">{campaign.metrics.unsubscribes}</TableCell>
      <TableCell align="right">{campaign.metrics.spamComplaints}</TableCell>
      <TableCell align="right">{campaign.metrics.deliveryFailures}</TableCell>
      <TableCell>
        <Chip size="small" label={campaign.status} />
      </TableCell>
      <TableCell>
        <Chip
          size="small"
          color={metricsStatusChipColor(campaign.metricsStatus)}
          label={campaign.metricsStatus}
        />
      </TableCell>
    </TableRow>
  );
}

export default NewsletterCampaignTableRow;
